import styled from '@emotion/styled'
import React, { type FunctionComponent, useMemo } from 'react'
import { fontSize, fontWeight, spacing } from '@retailer-platform/shared-components'
import { useDomainMessage } from 'domains/shifts/utils/domain/intl'

const Container = styled.div({
  display: 'flex',
  flexDirection: 'column',
  width: spacing.X128,
  padding: spacing.X8,
})

const ToolTipText = styled.div<{ bolded?: boolean }>(({ bolded }) => ({
  display: 'block',
  fontWeight: bolded ? fontWeight.BOLD : fontWeight.REGULAR,
  fontSize: fontSize.X12,
  lineHeight: fontSize.X18,
}))

const ShiftDetailsList = styled.ul({
  listStyleType: 'disc',
  listStylePosition: 'inside',
})

interface RecommendedShiftToolTipProps {
  timeString: string
  shiftDetails: string[]
}

export const RecommendedShiftToolTip: FunctionComponent<RecommendedShiftToolTipProps> = ({
  timeString,
  shiftDetails,
}) => {
  const shiftDetailsTitle = useDomainMessage('shiftsDomain.staffingAlert.shiftDetails')
  const listContent = useMemo(
    () => shiftDetails.map((detail, index) => <li key={index}>{detail}</li>),
    [shiftDetails]
  )
  return (
    <Container>
      <ToolTipText>{timeString}</ToolTipText>
      <ToolTipText bolded>{shiftDetailsTitle}</ToolTipText>
      <ShiftDetailsList>{listContent}</ShiftDetailsList>
    </Container>
  )
}
